import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function postRestorePassword(payload) {

  return $apiClient.post(`${ApiConfig.RESTORE}`,payload);
}
